import { render, staticRenderFns } from "./Warehouse_Stock_Transfer__detail.vue?vue&type=template&id=8c993e4e&scoped=true&"
import script from "./Warehouse_Stock_Transfer__detail.vue?vue&type=script&lang=js&"
export * from "./Warehouse_Stock_Transfer__detail.vue?vue&type=script&lang=js&"
import style0 from "./Warehouse_Stock_Transfer__detail.vue?vue&type=style&index=0&id=8c993e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c993e4e",
  null
  
)

export default component.exports